// noinspection JSUnresolvedVariable

import { DocumentsFolder, GraphQLURL, } from '../../core/App/Constants/AppData'
import isElectron from "is-electron";
import getMediaDownloadToken from "../../core/App/Components/FileDownload/GetMediaDownloadToken";

let electron;
if ( isElectron () ) {
    electron = window.require ( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

//Returns the value passed by params with the quantity of decimals passed by params.
export function round ( value, decimals ) {
    return Number ( Math.round ( value + 'e' + decimals ) + 'e-' + decimals );
}

//Return the fields of a JSON
export function getFields ( data, excludeds, addFirstEmptyColumn = true) {
    const json = data || {};
    let fields = [];
    // eslint-disable-next-line array-callback-return
    Object.entries ( json ).map ( ( key ) => {
        let excludedFound = false;

        excludeds && excludeds.map ( excluded => {
            if ( excluded === key[0] ) {
                excludedFound = true;
            }
            return ""
        } );


        if ( !excludedFound ) {
            fields.push ( key[0] )
        }

    } );

    if(addFirstEmptyColumn){
        return [ "", ...fields ];
    }else{
        return fields;
    }
}

export function getGraphQLError ( error ) {
    const { networkError } = error;
    let str = '';

    if ( networkError && networkError.statusCode ) str += `Status Code: ${ networkError.statusCode }`;
    if ( networkError && networkError.message ) str += `\nMessage: ${ networkError.message }`;
    if ( networkError && networkError.bodyText ) str += `\n${ networkError.bodyText }`;

    return str;
}

//Method to use in order to get the elements of the playlist.
//When the user doesn't have internet connection, this items will be shown in the playlist.
export function storePlaylistData ( playlist ) {
    ipcRenderer.send ( "storePlaylistData", playlist );
}

//Realizes an "INSERT INTO" action into the table lastConnection.
export function setLastLogin () {
    ipcRenderer.send ( 'setLastLogin' );
}

//Realizes an "INSERT INTO" action into the table documentsLikedByUser with the value "id"
export function markDocumentAsLiked ( id, entityType, name ) {
    //createDatabase();
    const data = {
        id,
        entityType,
        name
    }
    ipcRenderer.send ( 'markDocumentAsLiked', data );
}

//Realizes a Deletion from db at table documentsLikedByUser using the id passed through params.
export function unmarkDocumentAsLiked ( id, entityType ) {
    const data = {
        id,
        entityType
    }
    ipcRenderer.send ( 'unmarkDocumentAsLiked', data );
}

//Returns a promise in order to know if the user likes a document.
export function isDocumentLikedByUser ( id, entityType ) {
    const data = {
        id,
        entityType
    }
    ipcRenderer.send ( 'isDocumentLikedByUser', data )
}

//Gets all the data from the table "docs"
export function getAllLikesFromDB () {
    ipcRenderer.send ( 'getAllLikesFromDB' )
}

//Gets all the data from the table "docs"
export function getAllDocumentsFromDB () {
    ipcRenderer.send ( 'getAllDocumentsFromDB' )
}

export function openDocument ( doc ) {
    ipcRenderer.send ( "openDocumentViewer", doc );
}

//Sends an event to electron in order to download the file in the url.
export function downloadFile(file) {
    getMediaDownloadToken(
      file.uuid,
      file.sessionToken,
      (mediaDownloadTokenResponse) => {
        if (
          null == mediaDownloadTokenResponse
          || 'null' === mediaDownloadTokenResponse
          || undefined === mediaDownloadTokenResponse
        ) {
            ipcRenderer.send('removeItemFromDBQueue', file.id.toString());
            ipcRenderer.send('markAs404', {
                id: file.id.toString(),
                uuid: file.uuid
            });

            return;
        }

        let downloadFile;
        if (file.isProcessed) {
            downloadFile = file;
            downloadFile.uuid = file.uuid;
            downloadFile.sessionToken = file.sessionToken;

            return;
        }

        downloadFile = {
            name: file.filename,
            url: file.url,
            uuid: file.uuid,
            sessionToken: file.sessionToken,
            status: file.status,
            playlistID: file.playlistID || null,
            timelapse: file.timelapse,
            properties: {
                directory: DocumentsFolder,
                filename: file.filename,
                filesize: file.filesize,
                docname: file.docname,
                uuid: file.uuid,
                file_id: file.file_id,
                media_uuid: file.media_uuid,
                mimetype: file.mimetype,
                description: file.description,
                id: file.id,
                format: file.format,
                playlistID: file.playlistID || null,
                entityBundle: file.entityBundle,
                entityChanged: isNaN ( Date.parse ( file.entityChanged ) ) ? file.entityChanged : Date.parse ( file.entityChanged ),
                dateDownloaded: Date.now (),
                timelapse: file.timelapse,
            }
        }

        if ('AbortError' !== mediaDownloadTokenResponse) {
            downloadFile.url = file.url + '/' + mediaDownloadTokenResponse;
            ipcRenderer.send('download', downloadFile);
            return;
        }

        // Add the file to download once again to the bottom of the queue and issue a cancel command for the current download on top.
        ipcRenderer.send('timeoutDetected', file);
    })
    .catch((error) => {
        console.error("Error on 'getMediaDownloadToken': ", error);
    })
}

// Sends an event to electron in order to download the file in the url.
export function saveAs ( url ) {
    ipcRenderer.send ( 'saveAs', { url } );
}


export function setIntervalAndExecute ( fn, t ) {
    fn ();
    return ( setInterval ( fn, t ) );
}

//Convert rgb into hexadecimal value.
export function rgbToHex ( r, g, b ) {
    return "#" + componentToHex ( r ) + componentToHex ( g ) + componentToHex ( b );
}

// eslint-disable-next-line
function componentToHex ( c ) {
    const hex = c.toString ( 16 );
    return hex.length === 1 ? "0" + hex : hex;
}

// Convert HEX and ALPHA to RGBA
// hexToRgbA('#fbafff', 0.4)
export function hexToRgbA ( hex, alphaValue ) {
    let c;
    if ( /^#([A-Fa-f0-9]{3}){1,2}$/.test ( hex ) ) {
        c = hex.substring ( 1 ).split ( '' );
        if ( c.length === 3 ) {
            c = [ c[0], c[0], c[1], c[1], c[2], c[2] ];
        }
        c = '0x' + c.join ( '' );
        return 'rgba(' + [ ( c >> 16 ) & 255, ( c >> 8 ) & 255, c & 255 ].join ( ',' ) + ',' + alphaValue + ')';
    }
    throw new Error ( 'Bad Hex' );
}

export function checkStatus ( response ) {
    if ( response.status >= 200 && response.status < 300 ) return response;
    throw response;
}

export function parseJSON ( response ) {
    return response.json ();
}

export function translateMimetype ( input ) {
    //DECLARE CONSTANTS
    const PDF = "PDF";
    const MS_WORD = "MS Word";
    const ZIP = "ZIP";
    const NOT_AVAILABLE = "N/A";

    switch ( input ) {
        case "application/pdf":
            return PDF;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return MS_WORD;
        case "application/zip":
            return ZIP;
        case "application/octet-stream":
            return NOT_AVAILABLE;
        default:
            return input;
    }
}

export function keyEscHandler ( event, method ) {
    if ( event.which === 27 || event.keyCode === 27 ) {
        method ()
    }
}

export function keyReturnHandler ( event, method ) {

    if ( event.which === 13 || event.keyCode === 13 ) {
        method ()
    }
}

export function closeApp () {
    ipcRenderer.send ( 'closeApp' );
}

export function formatBytes ( a, b ) {
    if ( 0 === a ) return "0 Bytes";
    let c = 1024, d = b || 2, e = [ "Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB" ],
        f = Math.floor ( Math.log ( a ) / Math.log ( c ) );
    return parseFloat ( ( a / Math.pow ( c, f ) ).toFixed ( d ) ) + " " + e[f]
}

export function formatDate ( value ) {
    if ( value !== undefined && value !== null && value !== "" ) {
        const datePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
        const [ , year, month, day ] = datePattern.exec ( value );
        return `${ day }-${ month }-${ year }`;
    } else {
        return '';
    }
}
export const formatDateAsDay = ( inputDate ) =>  {
    // Create a Date object from the input string
    let date = new Date(inputDate);

    // Extract year, month, and day
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    let day = String(date.getDate()).padStart(2, '0'); // Ensure two digits

    // Return formatted date
    return `${year}-${month}-${day}`;
}

// Restructures received response row as a Playlist
// returns Playlist element.
export function processAsPlaylist ( res ) {
    return {
        metadata: {
            entityType: res.entityType,
            entityBundle: res.entityBundle,
            title: res.entityLabel,
            description: res.fieldPlaylistDescription,
            entityChanged: res.entityChanged,
        },
        type: 'playlist',
        isImportedFromSAP: res.fieldPlaylistImportedFromSap,
        id: res.entityId,
        likeId: res.entityId,
        actions: {
            like: res.isLikedByCurrentUser,
            isDownloaded: false,
            notifications: false
        },
        contextActions: [],
        showContextActions: true
    };
}

// Restructures the received response resource as a resource file
// returns a Resource File element.
export function getDocumentsFromResource ( resources ) {
    let docs = [];
    const viewableExtensions = [ "PDF" ]

    // eslint-disable-next-line
    resources && resources.fieldResourceFilesByFormat && resources.fieldResourceFilesByFormat.map ( ( res, index ) => {
        if ( res !== null ) {
            let filesize = "N/A";
            let language = "N/A";
            let filename = 'N/A';
            let version = '';
            let fromDate = null;
            let releaseDate = null;

            if ( res.entity && res.entity.entityBundle ) {
                if ( res.entity.entityBundle === "media_file" ) {
                    filesize = ( res.entity.fieldMediaFile && res.entity.fieldMediaFile.entity && res.entity.fieldMediaFile.entity.filesize ) ? res.entity.fieldMediaFile.entity.filesize : 'N/A';
                    language = ( res.entity.fieldMediaFileLanguage && res.entity.fieldMediaFileLanguage.value ) ? res.entity.fieldMediaFileLanguage.value : 'N/A';
                    filename = ( res.entity.fieldMediaFile && res.entity.fieldMediaFile.entity && res.entity.fieldMediaFile.entity.filename ) ? res.entity.fieldMediaFile.entity.filename : 'N/A';
                }

                if ( res.entity.entityBundle === "sap_file" ) {
                    filesize = res.entity.fieldSapFileFileSize ? res.entity.fieldSapFileFileSize : 'N/A';
                    language = ( res.entity.fieldSapFileLanguage && res.entity.fieldSapFileLanguage.value ) ? res.entity.fieldSapFileLanguage.value : 'N/A';
                    filename = res.entity.fieldSapFileFileName ? res.entity.fieldSapFileFileName : 'N/A';
                    version = res.entity.fieldSapFileDocumentVersion ? res.entity.fieldSapFileDocumentVersion : null;
                    fromDate = res.entity.fieldSapFromDate ? res.entity.fieldSapFromDate : null;
                    releaseDate = res.entity.fieldSapReleaseDate ? res.entity.fieldSapReleaseDate : null;
                }

                if (res.entity.entityBundle === "external_link"){
                    filesize = 'N/A';
                    language = 'N/A';
                    filename = res.entity.name;
                }

                if ( res.entity.entityBundle === "master_control" ) {
                    filesize = res.entity.fieldMasterControlSize ? parseInt(res.entity.fieldMasterControlSize) : 'N/A';
                    language = 'N/A';
                    filename = res.entity.entityLabel;
                    version = res.entity.fieldMasterControlRevision ? res.entity.fieldMasterControlRevision : null;
                }

                if ( res.entity.entityBundle === "master_control_attachment" ) {
                    language = 'N/A';
                    filesize = res.entity.fieldMcAttachmentSize ? parseInt(res.entity.fieldMcAttachmentSize) : 'N/A';
                    filename = res.entity.entityLabel;
                    version = res.entity.fieldMcAttachmentId ? res.entity.fieldMcAttachmentId : null;
                }
            }

            let extension = ( filename && filename !== 'N/A' ) ? filename.match ( /\.[0-9a-z]+$/i )[0].substring ( 1 ) : 'N/A';
            const doc = {
                metadata: {
                    name: res.entity && res.entity.entityLabel && res.entity.entityLabel,
                    filename: filename && filename !== "N/A" ? filename : res.entity && res.entity.entityLabel && res.entity.entityLabel,
                    filesize: filesize,
                    size: ( filesize && filesize !== "N/A" ) ? round ( filesize / ( 1000 * 1000 ), 2 ) + " MB" : "N/A",
                    mimetype: ( extension && extension !== 'N/A' ) ? extension.toUpperCase () : "N/A",
                    language: ( language && language !== "N/A" ) ? language.toUpperCase () : "N/A",
                    entityBundle: "file",
                    entityChanged: res.entity && res.entity.entityChanged,
                    fileIndex: index,
                    version: version,
                    fromDate: fromDate,
                    releaseDate: releaseDate
                },
                file: res.entity.uuid && `${ GraphQLURL }/media/${ res.entity.uuid }/download`,
                url: res.entity.uuid && `${ GraphQLURL }/media/${ res.entity.uuid }/download`,
                vIframe: ( res.entity && res.entity.fieldBokeccIframe ) ? res.entity.fieldBokeccIframe : null,
                id: resources.entityId,
                uuid: res.entity.uuid,
                file_id: res.entity.entityId,
                media_uuid: res.entity.uuid,
                likeId: res.entity.entityId,
                entityBundle: res.entity.entityBundle,
                actions: {
                    like: false,
                    notifications: false,
                    isDownloaded: false,
                },
                activities: {
                    canSaveAs: true,
                    canOpenInViewer: viewableExtensions.includes ( extension.toUpperCase () ),
                    canOpenStream: Object.keys ( res.entity ).includes ( 'fieldBokkeccIframe' )
                },
                bokeccVideo: res.entity.entityBundle === "bokecc_video",
                saveAs: res.entity.entityBundle !== "bokecc_video",
                defaultAction: null,
                isOnline: true,
                contextActions: []
            };

            docs.push ( doc );
        }

    } );
    return docs;
}


// Restructures the received response row as a Resource
// returns a Resource element
export function processAsResource ( res, index ) {
    if ( index === undefined ) {
        index = 0;
    }
    let filename;
    let filesize;
    let extension;
    let language;
    let entityBundle;
    let vIframe;
    let externalLink;
    const timelapse = res.fieldResourceOfflinePeriod ? Number ( res.fieldResourceOfflinePeriod.targetId ) : 2629800000; // is it defined? if not, default to 1 month in milliseconds
    const resource = res.fieldResourceFilesByFormat.filter ( item => item !== null );

    const fileEntities = resource && resource.map ( item => item.entity );

    const viewableExtensions = [ "PDF" ]
    let canOpenStream = false;
    let canSaveAs = false;
    let canDownload = false;
    let canViewDetail = false;
    let canOpenInViewer = false;
    let version = '';
    let fromDate = '';
    let releaseDate = '';

    const output = fileEntities.map ( fileEntity => {
        if ( Object.keys ( fileEntity ).includes ( 'fieldBokeccIframe' ) ) {
            filename = "N/A"
            filesize = 0;
            extension = "stream";
            language = "N/A";
            entityBundle = "bokecc_video";
            vIframe = fileEntity.fieldBokeccIframe;
            canOpenStream = true;
            canDownload = false;

        }else if ( Object.keys ( fileEntity ).includes ( 'fieldExternalLinkLink' ) ) {
            filename = "N/A"
            filesize = 0;
            extension = "link";
            language = "N/A";
            entityBundle = "external_link";
            externalLink = fileEntity.fieldExternalLinkLink.url.path;
            canOpenStream = true;
        } else {

            entityBundle = resource && fileEntity && fileEntity.entityBundle

            if ( entityBundle === "media_file" ) {
                extension = ( fileEntity.fieldMediaFile && fileEntity.fieldMediaFile.entity && fileEntity.fieldMediaFile.entity.filename ) ? fileEntity.fieldMediaFile.entity.filename.match ( /\.[0-9a-z]+$/i )[0].substring ( 1 ) : 'N/A';
                language = ( fileEntity.fieldMediaFileLanguage && fileEntity.fieldMediaFileLanguage.value ) ? fileEntity.fieldMediaFileLanguage.value : 'N/A';
                filesize = ( fileEntity.fieldMediaFile && fileEntity.fieldMediaFile.entity && fileEntity.fieldMediaFile.entity.filesize ) ? fileEntity.fieldMediaFile.entity.filesize : "N/A";
                filename = ( fileEntity.fieldMediaFile && fileEntity.fieldMediaFile.entity && fileEntity.fieldMediaFile.entity.filename ) ? fileEntity.fieldMediaFile.entity.filename : 'N/A';
            }

            if ( entityBundle === "sap_file" ) {
                extension = ( fileEntity.fieldSapFileFileExtension && fileEntity.fieldSapFileFileExtension.entity && fileEntity.fieldSapFileFileExtension.entity.fieldFileExtensionValue ) ? fileEntity.fieldSapFileFileExtension.entity.fieldFileExtensionValue : 'N/A';
                language = ( fileEntity.fieldSapFileLanguage && fileEntity.fieldSapFileLanguage.value ) ? fileEntity.fieldSapFileLanguage.value : 'N/A';
                filesize = fileEntity.fieldSapFileFileSize ? fileEntity.fieldSapFileFileSize : "N/A";
                filename = fileEntity.fieldSapFileFileName ? fileEntity.fieldSapFileFileName : 'N/A';
                version = fileEntity.fieldSapFileDocumentVersion ? fileEntity.fieldSapFileDocumentVersion : null;
                fromDate = fileEntity.fieldSapFromDate ? fileEntity.fieldSapFromDate : null;
                releaseDate = fileEntity.fieldSapReleaseDate ? fileEntity.fieldSapReleaseDate : null;
            }

            if ( entityBundle === "master_control" ) {
                extension = fileEntity.fieldMasterControlExtension && fileEntity.fieldMasterControlExtension.entity && fileEntity.fieldMasterControlExtension.entity.fieldFileExtensionValue ? fileEntity.fieldMasterControlExtension.entity.fieldFileExtensionValue : 'N/A';
                language = 'N/A';
                filesize = fileEntity.fieldMasterControlSize ? parseInt(fileEntity.fieldMasterControlSize) : 'N/A';
                filename = fileEntity.entityLabel;
                version = fileEntity.fieldMasterControlRevision ? fileEntity.fieldMasterControlRevision : null;
                fromDate = null;
                releaseDate = null;
            }

            if ( entityBundle === "master_control_attachment" ) {
                extension = fileEntity.fieldMcAttachmentExtension && fileEntity.fieldMcAttachmentExtension.entity && fileEntity.fieldMcAttachmentExtension.entity.fieldFileExtensionValue ? fileEntity.fieldMcAttachmentExtension.entity.fieldFileExtensionValue : 'N/A';
                language = 'N/A';
                filesize = fileEntity.fieldMcAttachmentSize ? parseInt(fileEntity.fieldMcAttachmentSize) : 'N/A';
                filename = fileEntity.entityLabel;
                version = fileEntity.fieldMcAttachmentId ? fileEntity.fieldMcAttachmentId : null;
                fromDate = null;
                releaseDate = null;
            }

            canSaveAs = true;
            canDownload = true;
            canViewDetail = resource.length > 1;
            canOpenInViewer = viewableExtensions.includes ( extension.toUpperCase () )
        }

        let metadataEntityCreated = resource && fileEntity.entityCreated;
        let metadataEntityChanged = resource && fileEntity.entityChanged;
        let entityCreated = res.entityCreated;
        let entityChanged = res.entityChanged;
        let resourceFromDate = res.fieldResourceFromDate ? res.fieldResourceFromDate : null;
        let resourceReleaseDate = res.fieldResourceReleaseDate ? res.fieldResourceReleaseDate : null;
        let fileFromDate = fileEntity.fieldSapFromDate ? fileEntity.fieldSapFromDate : null;
        let fileReleaseDate = fileEntity.fieldSapReleaseDate ? fileEntity.fieldSapReleaseDate : null;
        if (process.env.REACT_APP_SEE_DATES === "1") {
            metadataEntityCreated = resource && fileEntity.entityChanged;
            metadataEntityChanged = fileFromDate ?? fileReleaseDate;
            entityCreated = res.entityChanged;
            entityChanged = resourceFromDate ?? resourceReleaseDate;
        }

        return {
            metadata: {
                name: resource && res.entityLabel,
                filename: filename && filename !== "N/A" ? filename : resource && res.entityLabel,
                filesize: filesize,
                description: res.fieldResourceDescription,
                entityBundle: fileEntity.entityBundle,
                size: ( filesize && filesize !== "N/A" ) ? formatBytes ( filesize ) : "N/A",
                mimetype: ( extension && extension !== "N/A" ) ? extension.toUpperCase () : "N/A",
                language: ( language && language !== "N/A" ) ? language.toUpperCase () : "N/A",
                entityChanged: metadataEntityChanged,
                entityCreated: metadataEntityCreated,
                tags: res.fieldResourceTags,
                version: version
            },
            file: resource && fileEntity.uuid && `${ GraphQLURL }/media/${ fileEntity.uuid }/download`,
            url: resource && fileEntity.uuid && `${ GraphQLURL }/media/${ fileEntity.uuid }/download`,
            type: 'resource',
            isImportedFromSAP: res.fieldResourceImportedFromSap,
            vIframe: vIframe,
            externalLink: externalLink,
            resourceFilesCount: resource.length,
            id: res.entityId,
            entityChanged: entityChanged,
            entityCreated: entityCreated,
            uuid: res.uuid,
            file_id: fileEntity.entityId,
            media_uuid: fileEntity.uuid,
            likeId: res.entityId,
            timelapse,
            saveAs: true,
            actions: {
                like: res.isLikedByCurrentUser,
                notifications: false,
                isDownloaded: false,
            },
            activities: {
                canOpenStream,
                canSaveAs,
                canDownload,
                canViewDetail,
                canOpenInViewer,
            },
            defaultAction: null,
            isOnline: true,
            contextActions: [
                {
                    name: "Open Document",
                    action: null
                },
            ]
        }
    } )

    const filesInResource = output.map ( item => {
        return {
            metadata: {
                name: item.metadata.name,
                filename: item.metadata.filename,
                filesize: item.metadata.filesize,
                description: item.metadata.description,
                mimetype: item.metadata.mimetype,
                entityChanged: item.metadata.entityChanged,
                entityBundle: item.metadata.entityBundle,
                size: item.metadata.size,
                language: item.metadata.language,
            },
            file: item.file,
            playlistID: item.playlistID || null,
            url: item.url,
            id: item.id,
            file_id: item.file_id,
            media_uuid: item.media_uuid
        }
    } )
    if ( filesInResource.length < Number ( index ) + 1 ) {
        index = 0
    }
    const parsedResource = output[index];
    parsedResource.filesInResource = filesInResource;
    return parsedResource;
}

// Verifies if document is downloaded
export function CheckDocument ( file, ids ) {
    let foundOnDownloads = false;
    let myFile = file;

    if ( ids.includes ( file.id ) ) {
        foundOnDownloads = true;
        myFile.file = `${ DocumentsFolder }${ file.metadata.name }.${ file.metadata.mimetype }`;
    } else {
        myFile.file = myFile.url;
    }

    myFile.actions.isDownloaded = foundOnDownloads;

    return myFile;
}

// Marks Resources as downloaded in Desktop for Offline access
export function markResourceAsDownloaded ( ids, resources ) {
    let files = [];
    const resourcesToCheck = resources || [];
    resourcesToCheck.map ( ( file ) => {
        files.push ( CheckDocument ( file, ids ) );
        return null;
    } );

    return files;

}

export function triggerSearchAnalytics ( searchString, user ) {
    const searchAnalyticsEvent = new CustomEvent ( "triggerSearchAnalytics", { detail: { searchString, user } } );

    window.dispatchEvent ( searchAnalyticsEvent );
}

export function triggerVisitToSearchAnalytics ( searchString, user ) {
    const visitToSearchAnalytics = new CustomEvent ( "triggerVisitToSearchAnalytics", {
        detail: {
            searchString,
            user
        }
    } );

    window.dispatchEvent ( visitToSearchAnalytics );
}

export function triggerItemAnalytics ( data, user ) {
    const itemAnalytics = new CustomEvent ( "triggerItemAnalytics", { detail: { data, user } } );

    window.dispatchEvent ( itemAnalytics );
}

export function triggerLinkAnalytics ( data, user ) {
    const linkAnalytics = new CustomEvent ( "triggerLinkAnalytics", { detail: { data, user } } );

    window.dispatchEvent ( linkAnalytics );
}

export function triggerProfileAnalytics ( section ) {
    const profileAnalytics = new CustomEvent ( "triggerProfileAnalytics", { detail: { section } } );

    window.dispatchEvent ( profileAnalytics );
}

export function triggerItemStoreAnalytics ( data, user ) {
    const itemStoreAnalytics = new CustomEvent ( "triggerItemStoreAnalytics", { detail: { data, user } } );

    window.dispatchEvent ( itemStoreAnalytics );
}

export function triggerItemDownloadAnalytics ( data, user ) {
    const itemDownloadAnalytics = new CustomEvent ( "triggerItemDownloadAnalytics", { detail: { data, user } } );

    window.dispatchEvent ( itemDownloadAnalytics );
}

export function triggerPDFViewerAnalytics ( data, user ) {
    const pdfViewerAnalytics = new CustomEvent ( "triggerPDFViewerAnalytics", { detail: { data, user } } );

    window.dispatchEvent ( pdfViewerAnalytics );
}

export function triggerStreamViewerAnalytics ( data, user ) {
    const streamViewerAnalytics = new CustomEvent ( "triggerStreamViewerAnalytics", { detail: { data, user } } );

    window.dispatchEvent ( streamViewerAnalytics );
}
